import { createContext, use } from "react";
import type { AdminAccess } from "../lib/permissions";

export type AdminIdentity = {
  id: string;
  email: string | null;
};

export type AuthContextValue = {
  loading: boolean;
  access: AdminAccess | null;
  identity: AdminIdentity | null;
  login(email: string, password: string): Promise<void>;
  logout(): Promise<void>;
  refreshAccess(): Promise<void>;
};

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth() {
  const value = use(AuthContext);
  if (!value) throw new Error("AuthProvider_missing");
  return value;
}
